const props = {
  DATE_FORMATTER: 'yyyy-MM-dd',
  DATE_TO_SHOW: 'cc-LLL-yyyy',
};

export default props;
